<template>
<div class="tableContainer3" v-loading="loading">
  <div class="tableWrap">
    <el-table class="borderTable" stripe :max-height="tableMaxHeight || tableHeight" :row-class-name="tableRowClassName" :header-row-class-name="tableHeaderClassName" :data="tableData" style="width: 100%;" @selection-change="handleSelectionChange" ref="table">
      <slot></slot>
    </el-table>
    <!-- <div class="handleBottom" v-if="desc=='全选'">
         <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="selectAll()">全选</el-checkbox>
         <span @click="delData()">删除</span>
      </div> -->
  </div>
  <div class="pageWrap" v-if="pages.show && tableData">
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.currentPage" :page-sizes="pageSizes" :page-size="pages.pageSize" :pager-count="pagerCount" :layout="pageLayout" :total="pages.total"></el-pagination>
  </div>
</div>
</template>

<script>
export default {
  props: {
    desc: { //设置表格最大高度
      type: String,
      default: ''
    },
    tableMaxHeight: { //设置表格最大高度
      type: Number,
      default: 0
    },
    loading: { //是否显示加载中
      type: Boolean,
      default: false
    },
    tableData: { //表格数据
      type: Array,
      default: function () {
        return []
      }
    },
    pageSizes: { //可选的pageSizes
      type: Array,
      default: function () {
        return []
      }
    },
    pages: { //需要展示的page的控件的数组
      type: Object,
      default: function () {
        return {}
      }
    },
    tableRowClassName: { //表格行的类名
      type: String,
      default: 'opacityRowClass'
    },
    tableHeaderClassName: { //表格表头的类名
      type: String,
      default: 'opacityHeadClass'
    },
    //  batchDel:{
    //    type:Boolean,
    //    default:false
    //  } ,
  },
  watch: {
    tableData: {
      handler(newV, oldV) {
        // console.log(this.$refs.table)
        this.$refs.table.doLayout()
      },
      deep: true
    },
    screenData() {
      this.tableHeight = document.body.clientHeight - 330
    },
  },
  data() {
    return {
      pageLayout: 'total, sizes, prev, pager, next, jumper',
      pagerCount: 5,
      multipleTable: [], //存放选中值的数组
      arry: [],
      batchDel: false,
      checkAll: false,
      isIndeterminate: false,
      pagesize: 3,
      tableHeight: 82,
    };
  },
  created() {
    // console.log(this.tableMaxHeight);

  },
  mounted() {
    this.$nextTick(() => {
      // console.log(document.body.clientHeight);
      this.tableHeight = document.body.clientHeight - 550
    })
  },
  computed: {
    screenData() {
      return this.$store.state.screen;
    },
  },
  methods: {
    handleSizeChange(val) { //pageSize变化时函数
      this.$emit('sizeChange', val)
    },
    handleCurrentChange(val) { //当前页变化时函数
      this.$emit('currentChange', val)
    },
    handleSelectionChange(selection) { //多选框的选项变化是触发函数
      this.multipleTable = selection; //  this.multipleTable 选中的值
      this.$emit('selectionChange', selection)
      this.dialogFormAdd()

      let vlength = selection.length
      this.checkAll = vlength === this.pagesize
      // console.log(vlength > 0 && vlength < this.pagesize)
      this.isIndeterminate = vlength > 0 && vlength < this.pagesize

      if (selection.length != 0) {
        this.batchDel = true
      } else {
        this.batchDel = false
      }
    },
    //  selectAll(){//全选
    //    this.$refs.table.toggleAllSelection()
    //    console.log(this.tableData);   

    //    this.multipleTable=this.tableData
    //    this.$emit('selectionChange',this.multipleTable)
    //  },
    //  delData(){
    //    if(this.multipleTable.length==0){
    //      this.msg.warn("请先勾选删除内容！")
    //    }else{
    //      console.log(this.arry)
    //      let params={
    //        ids:this.arry.toString()
    //      }
    //      this.$confirm('此操作将永久删除内容, 是否继续?', '提示', {
    //        confirmButtonText: '确定',
    //        cancelButtonText: '取消',
    //        type: 'warning',
    //        center: true
    //      }).then(() => {
    //        this.request.delete("/card/batchDel",params).then(res=>{
    //          console.log(res)
    //          if(res.code==200){
    //            this.$message({
    //              type: 'success',
    //              message: '删除成功!'
    //            });
    //            this.$emit('delfirm',res.code)
    //          }
    //        })
    //      }).catch(() => {
    //        this.$message({
    //          type: 'info',
    //          message: '已取消删除'
    //        });          
    //      });
    //    }
    //  },
    dialogFormAdd() {
      let arr = []
      for (var i = 0; i < this.multipleTable.length; i++) {
        arr.push(this.multipleTable[i].id)
      }
      this.arry = arr
    },
  }
};
</script>

<style lang="scss" scoped>
.tableContainer3 {
  border: 0px solid #E6E6E6;

  .tableWrap {

    // margin-bottom: 30px;
    .handleBottom {
      height: 40px;
      background: #f4f4f4;
      color: #FF4C4C;
      // text-decoration: underline;
      line-height: 40px;
      padding-left: 14px;
      cursor: pointer;
    }
  }

  .pageWrap {
    margin-top: 20px;
    padding: 5px 0 5px 22px;
    border-top: 0px solid #E6E6E6;
  }
}
</style><style lang="scss">
.tableContainer3 {
  .tableWrap {
    .borderTable {
      &::before {
        display: none;
      }

      .opacityHeadClass {
        //   background:#f4f4f4;
        color: #33383E;

        th {
          background: #F4F7FA;
          font-size: 14px;
          font-family: AlibabaPuHuiTi-Medium;
          font-weight: 500;
          color: #33383E;

          &:nth-child(1) {
            .cell {
              padding-left: 14px;
            }
          }
        }
      }

      .opacityRowClass {
        //   background:#f4f4f4;
        color: #6F6F6F;

        td {
          border-bottom: 0px solid #E6E6E6;
          font-family: AlibabaPuHuiTi-Regular;
          font-weight: 400;
          color: #666A6F;

          .cell {

            .el-button--small,
            .el-button--small.is-round {
              padding: 4px 6px;
            }
          }
        }
        &.el-table__row--striped {
          background: rgba(16, 137, 255, 0.03);
        }
      }

      .el-table__fixed-right::before {
        display: none;
      }

      .el-table-column--selection {
        border-right: 0px solid #E6E6E6;
        box-shadow: 2px 0 3px -1px #E6E6E6; //右边阴影
        z-index: 10 !important;
      }
    }
  }

  .pageWrap {
    .el-pagination {
      .el-pager {
        li {
          &.active {
            background-color: #1089FF;
          }
        }
      }
    }

    .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #1089FF;
      color: #FFF;
    }
  }

  .handleBottom {
    .el-checkbox {
      color: #222;
      margin-right: 15px;
    }
  }
}
</style>
